<link rel="ractive" href="./select.html" name="c-select">
<link rel="ractive" href="./location-input.html" name="c-location-input">

<div class="gp-probe-filters">
	<div class="gp-probe-filters_row">
		<div class="gp-probe-filters_field gp-probe-filters_field--location">
			<c-location-input
				rawProbes="{{rawProbes}}"
				value="{{location}}"
				error="{{locationError}}"
				placeholder="Enter location"
				labelText="Location"
				classList="gp_map-block_settings-wrapper_settings_location gp_input"
				ttPos="{{ttPositions.locationTtPos}}"
				exposeProbes="{{true}}"
				results="{{locationProbes}}"
				completedValue="{{locationCompletedValue}}"
				reshapeResults="{{reshapeResults}}"
				locationTooltipContent="{{locationTooltipContent}}"
				supportedFeaturesMessage={{supportedFeaturesMessage}}>
				{{#partial labelIcon}}
				<img
					as-tooltip="locationTooltipContent, ttPos, undefined, undefined, 'multiline'"
					width="14"
					height="14"
					src="{{@shared.assetsHost}}/img/help-icon.svg"
				>
				{{/partial}}
			</c-location-input>
		</div>

		{{#if showGroupBy}}
			<div class="gp-probe-filters_field gp-probe-filters_field--group-by">
				<label>Group by</label>
				<c-select
					options="{{groupingOptions}}"
					selected="{{groupBy}}"
					name="group-by-select"
				/>
			</div>
		{{/if}}

		{{#if showSortOrder}}
			<div class="gp-probe-filters_field gp-probe-filters_field--sort-by">
				<label>Sort by</label>
				<c-select
					options="{{sortOptions}}"
					disabled="{{showGroupBy && groupBy === 'disabled'}}"
					selected="{{sortOrder}}"
					name="sort-by-select"
				/>
			</div>
		{{/if}}
	</div>
	<div class="gp-probe-filters_quick">
		<span class="gp-probe-filters_quick_title">
			<span>Quick Filters:</span>
		</span>

		<div class="gp-probe-filters_quick_list">
			{{#each filtersSet}}
				<span class="gp-probe-filters_quick_list_selected">
					{{this.name}}
					<button data-testid="quick-filter-{{this.name}}" on-click="@this.rmFilterRule(@key)"
						type="button"
						aria-label="Remove {{this.name}} filter"
						class="gp-probe-filters_quick_list_selected_remove">
					<img width="16" height="16" alt="" src="{{@shared.assetsHost}}/img/tag-input-close-icon.svg">
					</button>
				</span>
			{{/each}}

			{{#each availableFilters}}
				{{#unless this.selected}}
					<button data-testid="quick-filter-{{this.name}}" on-click="@this.setFilterRule(@key)"
						type="button"
						class="gp-probe-filters_quick_list_item">
						{{this.name}}
					</button>
				{{/unless}}
			{{/each}}
		</div>
	</div>
</div>

<script>
	const FILTER_TYPE_BY_CONTINENT = 'byContinent';
	const FILTER_TYPE_BY_NETWORK = 'byNetwork';

	component.exports = {
		data () {
			return {
				addNetworks: true,
				showGroupBy: true,
				showSortOrder: true,
				availableFilters: [
					{
						name: 'Europe',
						value: 'Europe',
						type: FILTER_TYPE_BY_CONTINENT,
					},
					{
						name: 'North America',
						value: 'North America',
						type: FILTER_TYPE_BY_CONTINENT,
					},
					{
						name: 'South America',
						value: 'South America',
						type: FILTER_TYPE_BY_CONTINENT,
					},
					{
						name: 'Africa',
						value: 'Africa',
						type: FILTER_TYPE_BY_CONTINENT,
					},
					{
						name: 'Asia',
						value: 'Asia',
						type: FILTER_TYPE_BY_CONTINENT,
					},
					{
						name: 'Oceania',
						value: 'Oceania',
						type: FILTER_TYPE_BY_CONTINENT,
					},
					{
						name: 'eyeball network',
						value: 'eyeball-network',
						type: FILTER_TYPE_BY_NETWORK,
					},
					{
						name: 'datacenter',
						value: 'datacenter-network',
						type: FILTER_TYPE_BY_NETWORK,
					},
				],
				filtersSet: null,
			};
		},
		computed: {
			locationTooltipContent () {
				return [
					`This magic field supports names of continents, regions, countries, US states, cities, ${this.get('addNetworks') ? 'networks, ' : ''}and our custom tags.`,
					'',
					'Use + to combine multiple filters.',
					'Use , to select multiple locations.',
				];
			},
			supportedFeaturesMessage () {
				if (this.get('addNetworks')) {
					return undefined;
				}

				return 'Our magic search supports names of continents, regions, countries, US states, cities, and custom tags.';
			},
			reshapeResults () {
				if (this.get('addNetworks')) {
					return sources => sources;
				}

				return sources => sources.filter(source => source.sourceId !== 'networks');
			},
		},
		oninit () {
			if (!Ractive.isServer) {
				this.observe('location', () => {
					this.updateFiltersSet();
				});
			}
		},
		updateFiltersSet () {
			let location = this.get('location');
			let availableFilters = this.get('availableFilters');
			availableFilters.forEach(f => f.selected = false);

			if (!location) {
				this.set('filtersSet', []);
				this.set('availableFilters', availableFilters);
				return;
			}

			let parts = location.split(/[+,]/).map(p => p.trim().toLowerCase());
			let filtersSet = [];

			availableFilters.forEach((f, i) => {
				let part = parts.find((part) => {
					return f.name.toLowerCase() === part || f.value.toLowerCase() === part;
				});

				if (part) {
					f.selected = true;
					f.avFiltersIdx = i;
					filtersSet.push(f);
				}
			});

			this.set('filtersSet', filtersSet);
			this.set('availableFilters', availableFilters);
		},
		setFilterRule (idx) {
			let availableFilters = this.get('availableFilters');
			let selectedFilter = availableFilters[idx];
			let location = this.get('location');

			if (!location) {
				this.set('location', selectedFilter.value);
			} else {
				let parts = location.split(',').map(query => query.split('+').map(p => p.trim().toLowerCase())).flat();
				let hasContinent = false;
				let hasNetwork = false;

				for (let f of availableFilters) {
					let matchingPart = parts.find(part => part === f.name.toLowerCase() || part === f.value.toLowerCase());

					if (matchingPart) {
						if (f.type === FILTER_TYPE_BY_CONTINENT) {
							hasContinent = true;
						} else if (f.type === FILTER_TYPE_BY_NETWORK) {
							hasNetwork = true;
						}
					}
				}

				if (selectedFilter.type === FILTER_TYPE_BY_NETWORK && hasContinent && !hasNetwork) {
					this.set('location', `${location}+${selectedFilter.value}`);
				} else if (selectedFilter.type === FILTER_TYPE_BY_CONTINENT && hasNetwork && !hasContinent) {
					this.set('location', `${location}+${selectedFilter.value}`);
				} else {
					this.set('location', selectedFilter.value);
				}
			}

			this.findComponent('c-location-input')?.fire('outsideLocationChange');
		},
		rmFilterRule (idx) {
			let filter = this.get('filtersSet')[idx];
			let selectedFilter = this.get('availableFilters').find(f => f.value === filter.value);
			let location = this.get('location');

			if (location.includes(selectedFilter.value)) {
				let parts = location.split(',');
				let updatedParts = parts.map((part) => {
					let segments = part.split('+').map(s => s.trim());
					let filteredSegments = segments.filter(s => s.toLowerCase() !== filter.value.toLowerCase());
					return filteredSegments.join('+');
				}).filter(part => part.trim() !== '');

				this.set('location', updatedParts.join(',') || 'World');
			}

			this.findComponent('c-location-input')?.fire('outsideLocationChange');
		},
	};
</script>
